<template>
	<div class="w-100">
		<div class="card">
			<div class="card-header bg-primary text-white">
				<div class="card-title h5 m-0">{{$t('coordinations.pageTitle')}}</div>
			</div>

			<div class="btn-toolbar justify-content-between mb-0 mt-3" role="toolbar">
				<div class="col-w"></div>
				<div class="input-group">
					<input
						v-model="searchQuery"
						v-on:keyup.enter.stop="massSearch"
						v-on:keyup.esc.stop="clearFilters"
						type="text"
						class="form-control"
						aria-label="Mass search input"
						aria-describedby="massSearch"
					/>
					<button class="btn btn-secondary" @click.stop="massSearch">
						<i class="fas fa-search"></i>
						{{ $t('buttons.search.btnText') }}
					</button>
					<button class="btn btn-secondary" @click.stop="clearFilters">
						<i class="fas fa-times"></i>
						{{ $t('buttons.clearFilters.btnText') }}
					</button>
				</div>
			</div>

			<div class="card-body">
				<div class="grid-wrapper">
					<kendo-datasource
						ref="datasource"
						:transport="transportSettings"
						:schema-model-fields="schemaModelFields"
						:schema-model-id="'id'"
						:schema-total="'total'"
						:schema-data="'data'"
						:page-size="defaultGridRows"
						:server-paging="true"
						:server-sorting="true"
						:server-filtering="true"
						:change="onChange"
					></kendo-datasource>

					<kendo-grid
						ref="coordsGrid"
						:data-source-ref="'datasource'"
						:navigatable="gridOptions.navigatable"
						:editable="false"
						:filterable="gridOptions.filterable"
						:pageable="gridOptions.pageable"
						:reorderable="gridOptions.reorderable"
						:resizable="gridOptions.resizable"
						:groupable="gridOptions.groupable"
						:allow-copy="gridOptions.allowCopy"
						:column-menu="gridOptions.columnMenu"
						:sortable-mode="gridOptions.sortable.mode"
						:sortable-allow-unsort="gridOptions.sortable.allowUnsort"
						:sortable-show-indexes="gridOptions.sortable.showIndexes"
						:selectable="gridOptions.selectable"
						:scrollable="gridOptions.scrollable"
						:dataBound="onDatabound"
					>
						<kendo-grid-column
                            :template="btnsTemplate" :width="150" :columnMenu="false" field="btnsColumn" :title="$t('actions')"></kendo-grid-column>
						<kendo-grid-column :field="'id'" :title="'Id'" :width="100" :lockable="true" :locked="false"></kendo-grid-column>
						<kendo-grid-column :field="'title'" :title="$t('coordinations.title')" :width="300" :lockable="true" :locked="false"></kendo-grid-column>
						<kendo-grid-column :field="'status'" :title="$t('coordinations.status')" :width="200" :lockable="true" :locked="false"></kendo-grid-column>
						<kendo-grid-column :field="'createdByUserName'" :title="$t('coordinations.createdBy')" :width="200" :lockable="true" :locked="false"></kendo-grid-column>
						<kendo-grid-column :field="'coordinatorsAsString'" :title="$t('coordinations.coordinators')" :width="200" :lockable="true" :locked="false"></kendo-grid-column>
						<kendo-grid-column
							:field="'deadline'"
							:title="$t('coordinations.deadline')"
							:width="200"
							:lockable="true"
							:locked="false"
							:format="'{0:dd.MM.yyyy H:mm}'"
						></kendo-grid-column>
						<kendo-grid-column :field="'type'" :title="$t('coordinations.type')" :width="200" :lockable="true" :locked="false"></kendo-grid-column>
						<kendo-grid-column :field="'archived'" :title="$t('coordinations.archived')" :width="200" :lockable="true" :locked="false" :template="boolCellTemplate"></kendo-grid-column>
					</kendo-grid>
				</div>
			</div>
		</div>
		<DisplayModal :value="displayModel" :show="showDisplay" @onClose="onDisplayClose"></DisplayModal>
	</div>
</template>

<script>
import Vue from 'vue';
import $ from 'jquery';
import DisplayModal from '../../components/coordinations/display.modal';
import BtnsTemplate from '../../components/grid/StandardBtnsTemplate';
import coordsService from '../../services/coordinations.service';
import { CoordinationStatus } from '@/models/enums';
import { mapGetters } from 'vuex'

export default {
	components: {
		DisplayModal
	},
	data() {
		return {
			transportSettings: {
				read: {
					url: this.$store.getters.baseUrl + '/api/coordinations/all',
					dataType: 'json',
					type: 'POST',
					contentType: 'application/json',
					beforeSend: this.beforeSend
				},
				parameterMap: this.parameterMap
			},
			defaultGridRows: this.$store.getters.defaultGridRows,
			showDisplay: false,
			displayModel: null,
			activeTaskId: null,
			searchQuery: '',
			schemaModelFields: {
				id: { field: 'id', type: 'number', nullable: false, editable: false },
				title: { field: 'title', type: 'string', nullable: true, editable: false },
				createdOn: { field: 'createdOn', type: 'date', nullable: true, editable: false },
				createdByUserName: { field: 'createdByUserName', type: 'string', nullable: true, editable: false },
				coordinatorsAsString: { field: 'coordinatorsAsString', type: 'string', nullable: true, editable: false },
				deadline: { field: 'deadline', type: 'date', nullable: true, editable: false },
				type: { field: 'type', type: 'string', nullable: true, editable: false },
				status: { field: 'status', type: 'string', nullable: true, editable: false },
				archived: { field: 'archived', type: 'boolean', nullable: true, editable: false }
			}
		};
	},
	methods: {
		onDatabound(e) {
			var items = e.sender.items();
			items.each(function(idx, item) {
				let dataItem = e.sender.dataItem(item);
				if (dataItem.statusId < 4) {
					$(item).addClass('left-border-danger');
				} else if (dataItem.statusId === 4) {
					$(item).addClass('left-border-blue');
				}
			});
		},
		parameterMap: function(options, operation) {
			if (operation !== 'read' && options.models) {
				return { models: kendo.stringify(options.models) };
			} else {
				return kendo.stringify(options);
			}
		},
		onChange(data) {
			// parse date field in the grid data
			data.items.forEach(item => {
				item.deadline = new Date(item.deadline);
				item.createdOn = new Date(item.createdOn);
			});
		},
		beforeSend: function(req) {
			if (this.token) {
				req.setRequestHeader('Authorization', 'Bearer ' + this.token);
			}
		},
		boolCellTemplate: function(dataItem) {
			let templateHtml =
				'<div class="text-center"><span class="badge ' +
				(dataItem.archived ? 'badge-success' : 'badge-secondary') +
				'">' +
				kendo.htmlEncode(dataItem.archived ? this.$t('yes') : this.$t('no')) +
				'</span></div>';

			return templateHtml;
		},
		btnsTemplate: function(e) {
			return {
				template: Vue.component(BtnsTemplate.name, BtnsTemplate),
				templateArgs: {
					...e,
					btns: [
						{
							name: 'details',
							text: '',
							tooltip: this.$t('buttons.details.tooltipText'),
							class: 'btn btn-info',
							icon: 'fas fa-eye',
							show: this.hasReadRights,
							clickHandler: this.showDetailsModal
						},
						{
							name: 'archive',
							text: '',
							tooltip: this.$t('tasks.archive_v'),
							class: 'btn btn-danger',
							icon: 'fas fa-archive',
							show:
								!e.archived &&
                                this.hasEditRights &&
								(e.statusId === CoordinationStatus.completed || e.statusId === CoordinationStatus.canceled),
							clickHandler: this.onArchiveTask
						},
						{
							name: 'unarchive',
							text: '',
							tooltip: this.$t('tasks.unarchive_v'),
							class: 'btn btn-danger',
							icon: 'fas fa-archive',
                            show: e.archived && this.hasEditRights,
							clickHandler: this.onUnarchiveTask
						}
					]
				}
			};
		},
		showCoordination(taskId) {
            this.$http
                .get('/api/coordinations/get/' + taskId)
                .then(response => {
                    this.showDetailsModal(response.data);
                })
                .catch(err => {
                    this.$vs.notify({
                        color: 'danger',
                        title: this.$t('notifications.error'),
                        text: this.$helpers.errorText(err)
                    });
                });
        },
		showDetailsModal(e) {
            if (!this.hasReadRights) {
                return this.$router.push(`/unauthorized`);
            }

			this.displayModel = { ...e };
			this.showDisplay = true;
		},
		onDisplayClose() {
			this.showDisplay = false;
			this.displayModel = null;
		},
		onUnarchiveTask(e) {
			this.activeTaskId = e.id;
			this.$vs.dialog({
				type: 'confirm',
				color: 'success',
				title: this.$t('coordinations.unarchive'),
				text: this.$t('coordinations.unarchiveMessage'),
				accept: this.unarhiveTask,
				acceptText: this.$t('buttons.ok'),
				cancelText: this.$t('buttons.cancel'),
				cancel: () => (this.activeTaskId = null)
			});
		},
		onArchiveTask(e) {
			this.activeTaskId = e.id;
			this.$vs.dialog({
				type: 'confirm',
				color: 'success',
				title: this.$t('coordinations.archive'),
				text: this.$t('coordinations.archiveMessage'),
				accept: this.arhiveTask,
				acceptText: this.$t('buttons.ok'),
				cancelText: this.$t('buttons.cancel'),
				cancel: () => (this.activeTaskId = null)
			});
		},
		onModalClose() {
			this.activeTaskId = null;
		},
		unarhiveTask() {
			coordsService
				.unarchive(this.activeTaskId)
				.then(() => {
					this.$vs.notify({
						color: 'success',
						title: this.$t('updateSuccess'),
						text: ''
					});
					this.refresh();
				})
				.catch(err =>
					this.$vs.notify({
						color: 'danger',
						title: this.$t('notifications.error'),
						text: this.$helpers.errorText(err)
					})
				)
				.then(() => (this.activeTaskId = null));
		},
		arhiveTask() {
			coordsService
				.archive(this.activeTaskId)
				.then(() => {
					this.$vs.notify({
						color: 'success',
						title: this.$t('updateSuccess'),
						text: ''
					});
					this.refresh();
				})
				.catch(err =>
					this.$vs.notify({
						color: 'danger',
						title: this.$t('notifications.error'),
						text: this.$helpers.errorText(err)
					})
				)
				.then(() => (this.activeTaskId = null));
		},
		refresh() {
			this.$refs['coordsGrid'].kendoWidget().dataSource.read();
		},
		clearFilters() {
			this.searchQuery = '';
			const grid = this.$refs.coordsGrid.kendoWidget();
			if (grid) {
				grid.dataSource.sort({});
				grid.dataSource.page(1);
				grid.dataSource.aggregate([]);
				grid.dataSource.filter({});
			}
		},
		massSearch() {
			if (!this.searchQuery) {
				this.$vs.notify({
                    title: this.$t('buttons.search.btnText'),
                    text: this.$t('emptySearchFilter'),
					color: 'warning',
					time: this.$store.getters.notificationDuration
				});

				return;
			}

			let grid = this.$refs.coordsGrid.kendoWidget();
			if (grid) {
				let filter = this.$helpers.getMassFilterForGrid(grid, this.searchQuery);
				if (filter) {
					grid.dataSource.filter(filter);
				}
			}
		}
	},
	computed: {
        ...mapGetters(['gridOptions']),
		token: function() {
			return this.$store.getters.authToken;
		},
		hasReadRights() {
            return this.$store.getters.claims.coordinationsAdministration.read;
		},
		hasEditRights() {
            return this.$store.getters.claims.coordinationsAdministration.update;
		}
	},
	mounted() {
		// this.refresh();
		if (this.$route.query['view']) {
            var taskId = this.$route.query['view'];
			this.showCoordination(taskId.trim());
         }
	}
};
</script>

<style>
</style>
